import { useEffect } from "react";
import { Col, Row, Card, Button } from "antd";
import StorageService from "../../util/storage";
import useAuth from "../../hooks/useAuth";

export default function EmailConfirmation() {
    const { auth } = useAuth();
    // get token from query param
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    useEffect(() => {
        // call api to confirm email
        if (token) {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/busable-inject-functions/confirm-account`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token }),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    const user = StorageService.getItem("user");
                    user.confirmed = true;
                    StorageService.setItem("user", user);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }, [token]);

    return (
        <div className="Login">
            <div className="AppContainer">
                <Row justify="center" align="middle">
                    <Col xs={24} md={14} lg={10}>
                        <Card>
                            <h1 className="SectionTitle">
                                Congratulations!
                                <br />
                                Your Account is Activated
                            </h1>
                            <p>
                                Your account has been successfully activated. You can now log in and enjoy all the features of our platform.
                            </p>
                            {auth.isLoggedIn() ? (
                                <Button href="/" type="primary" size="small" style={{ width: "100%", margin: "40px auto" }}>
                                    Go to Dashboard
                                </Button>
                            ) : (
                                <Button href="/login" type="primary" size="small" style={{ width: "100%", margin: "40px auto" }}>
                                    Login to Your Account
                                </Button>
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
